"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "addItemToCart", {
    enumerable: true,
    get: ()=>addItemToCart
});
const _graphqlRequest = require("graphql-request");
const _checkoutFragment = require("../fragments/checkout-fragment");
const addItemToCart = (0, _graphqlRequest.gql)`
    mutation AddItemToCheckout(
        $retailerId: ID!
        $checkoutId: ID!
        $productId: ID!
        $quantity: Int!
        $option: String!
    ) {
        addItem(
            retailerId: $retailerId
            checkoutId: $checkoutId
            productId: $productId
            quantity: $quantity
            option: $option
        ) {
            ...checkoutFragment
        }
    }
    ${_checkoutFragment.CHECKOUT_FRAGMENT}
`;
